// ---- War Room Performance — site content & config ----

export const GYMDESK_BOOKING_URL = "";
export const GOOGLE_CALENDAR_BOOKING_URL = "";
export const BASE44_ASSISTANT_URL = "";

export const openBooking = () => {
  if (GYMDESK_BOOKING_URL) {
    window.open(GYMDESK_BOOKING_URL, "_blank", "noopener,noreferrer");
  } else {
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  }
};

export const CONTACT = {
  business: "War Room Performance",
  addressLines: ["50 Muller Dr. Unit 10", "St. Augustine, FL 32084"],
  address: "50 Muller Dr. Unit 10, St. Augustine, FL 32084",
  phone: "(904) 640-9047",
  phoneHref: "+19046409047",
  email: "war.room.performancemt@mail.com",
};

export const SOCIAL_LINKS = {
  instagramHandle: "@war.room.performance",
  instagramUrl: "https://www.instagram.com/war.room.performance",
  facebookUrl: "https://www.facebook.com/profile.php?id=61552470180581",
  facebookReviewUrl:
    "https://www.facebook.com/profile.php?id=61552470180581&sk=reviews&write_review=1",
};

export const GOOGLE_REVIEW_URL = "https://g.page/r/CaCE8Huy5HC6EAE/review";

const MAPS_QUERY = encodeURIComponent(
  "War Room Performance, 50 Muller Dr Unit 10, St. Augustine, FL 32084"
);
export const MAPS = {
  embedUrl: `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`,
  directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`,
};

export const SOCIALS = [
  { label: "Instagram", href: SOCIAL_LINKS.instagramUrl, icon: "instagram" },
  { label: "Facebook", href: SOCIAL_LINKS.facebookUrl, icon: "facebook" },
];

// Authentic War Room Performance imagery (uploaded assets).
export const IMAGES = {
  // Circular emblem logo (WAR ROOM PERFORMANCE with fighter silhouettes + stars).
  // Vector SVG traced from the corrected raster so it renders crisp at any
  // size on Retina/high-DPI displays. Raster fallback kept for Scene3D
  // (imagetracerjs needs a bitmap input).
  logo: "/logo.svg",
  logoRaster: "/logo.png",
  heroClass:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/y1chwum8_Class%20Shot.jpg",
  // Gym interior — original file is stored sideways; served here already rotated
  // to natural upright landscape (see /app/frontend/public/gym-interior.webp).
  heroFloor: "/gym-interior.webp",
  gymInterior: "/gym-interior.webp",
  adult:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/b667nu03_IMG_5784.webp",
  kids:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/vlgs1tdn_Kids%20Class.webp",
  privateLessons:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/c3iba5eo_IMG_4266.webp",
  fighterTeam:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/4vm9vjtw_Jonah%20%26%20Tyler.JPEG",
  coachNicky:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/raozomi0_Hurricane%201.jpeg",
  coachJJ:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_warrior-nexus-4/artifacts/vitt6rc3_IMG_8436.jpg",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Christ-Centered",
    body:
      "We train with purpose beyond the mirror. Every session begins and ends in gratitude — a clean, welcoming community built on faith, respect, and discipline.",
  },
  {
    n: "02",
    title: "Elite Standard",
    body:
      "Authentic Muay Thai coaching held to a professional standard. No egos, no shortcuts — only precise technique, honest effort, and measurable progress.",
  },
  {
    n: "03",
    title: "Everyone Belongs",
    body:
      "First-timers and fighters share the same floor. We meet you where you are and forge you into who you're becoming — one round at a time.",
  },
];

export const CLASSES = [
  {
    title: "Teens & Adults Muay Thai",
    tag: "Ages 13+ · Mon–Thu",
    desc:
      "Two class levels for teens and adults (ages 13+). Beginners Muay Thai (7:30 PM) is designed for beginners and developing students — Muay Thai fundamentals, technique, conditioning, pad work, partner drills, and building a strong technical foundation. No previous Muay Thai or combat sports experience required. Advanced Muay Thai (6:30 PM) is higher-level training for experienced students and fighters; sessions vary based on experience, upcoming fights, individual development, and the needs of the fight team.",
    span: "lg:col-span-8",
    img: "adult",
    accent: "pink",
  },
  {
    title: "Kids Muay Thai",
    tag: "Youth · Tue & Thu, 5:00 PM",
    desc:
      "Authentic Muay Thai fundamentals in a structured, disciplined, and encouraging environment. Students develop technique, coordination, confidence, discipline, respect, and physical conditioning while learning real Muay Thai. Classes are structured around proper technique, safety, development, and age-appropriate training.",
    span: "lg:col-span-4",
    img: "kids",
    accent: "teal",
  },
  {
    title: "Private Lessons",
    tag: "1-on-1 · By Appointment",
    desc:
      "Individualized Muay Thai instruction based on your goals, experience level, and areas of development. Sessions can focus on fundamentals, technical refinement, pad work, fight preparation, or specific areas that need additional attention. Available for beginners, experienced students, fighters, and youth athletes.",
    span: "lg:col-span-4",
    img: "privateLessons",
    accent: "teal",
  },
  {
    title: "Fighter Team / Advanced Program",
    tag: "By Coaching Staff",
    desc:
      "War Room develops fighters through the Advanced Muay Thai program and dedicated fight preparation. Training varies depending on the athlete's experience, readiness, commitment, upcoming competition, and individual development. Participation in the fight team and competition preparation is determined by the coaching staff. This is not an open beginner program and is not offered as a separate daily scheduled class.",
    span: "lg:col-span-8",
    img: "fighterTeam",
    accent: "pink",
  },
];

export const COACHES = [
  {
    slug: "nicky",
    eyebrow: "Head Coach, Owner, and Active Fighter",
    name: "Nick Villanueva",
    shortName: "Coach Nicky",
    experience: "7+ Years in Combat Sports",
    lineage: "Chute Boxe Diego Lima // Coached under Carlos Paltronieri",
    img: "coachNicky",
    bio: [
      "With a heart for people and excellence, Coach Nicky set out to be a different name in combat sports. With more than seven years in combat sports, a background coming from Chute Boxe Diego Lima, and having been coached under Carlos Paltronieri, he brings real competitive experience and technical development into War Room Performance.",
      "As Head Coach, Owner, active fighter, and Head Coach of the Competition Team, Coach Nicky leads War Room's overall coaching system — from developing complete beginners to preparing experienced athletes for competition.",
      "He created War Room Performance with a vision of building more than just a local Muay Thai gym — a place committed to going above and beyond in professionalism, community, and the development of its people.",
      "The War Room was designed to teach people how to prepare for life — the biggest war of all.",
    ],
  },
  {
    slug: "jj",
    eyebrow: "Co-Owner, Coach, and Head Coach of the Women",
    name: "Coach JJ",
    shortName: "Coach JJ",
    experience: "5 Years in Combat Sports",
    lineage: "Kings MMA — Anaheim, CA // Coached by Nolan Ticman",
    img: "coachJJ",
    bio: [
      "Coming from Kings MMA in Anaheim, California, Coach JJ brings five years of Muay Thai and combat sports experience to War Room Performance.",
      "Having been coached by former UFC fighter Nolan Ticman, Coach JJ developed a hands-first Muay Thai approach that brings a different technical perspective to the War Room.",
      "As Co-Owner, Coach, Back Office Operations Manager, and Head Coach of the Women at War Room Performance, Coach JJ plays an important role both on and off the mats. She also contributes her technical perspective to the development of War Room's competitors while Coach Nicky remains Head Coach of the Competition Team.",
      "Community-first, Coach JJ is committed to helping War Room remain set apart from the rest of the combat sports industry through professionalism, authentic coaching, strong relationships, and genuine investment in the people who walk through the doors.",
    ],
  },
];

export const SCHEDULE = [
  {
    day: "Mon",
    sessions: [
      { time: "6:30 PM", name: "Advanced Muay Thai" },
      { time: "7:30 PM", name: "Beginners Muay Thai" },
    ],
  },
  {
    day: "Tue",
    sessions: [
      { time: "5:00 PM", name: "Kids Muay Thai" },
      { time: "6:30 PM", name: "Advanced Muay Thai" },
      { time: "7:30 PM", name: "Beginners Muay Thai" },
    ],
  },
  {
    day: "Wed",
    sessions: [
      { time: "6:30 PM", name: "Advanced Muay Thai" },
      { time: "7:30 PM", name: "Beginners Muay Thai" },
    ],
  },
  {
    day: "Thu",
    sessions: [
      { time: "5:00 PM", name: "Kids Muay Thai" },
      { time: "6:30 PM", name: "Invitation Sparring", invitationOnly: true },
      { time: "7:30 PM", name: "Beginners Muay Thai" },
    ],
  },
];

// Gallery pulls from authentic images we have. No duplicates from other
// dedicated sections; more real photos can be added when supplied.
export const GALLERY = ["heroClass", "adult", "kids", "heroFloor"];

export const PROGRAMS_FOR_FORM = [
  "Teens & Adults Muay Thai",
  "Kids Muay Thai",
  "Private Lessons",
  "Fighter Team / Advanced Program",
  "Not sure yet",
];

export const MARQUEE_WORDS = [
  "CHRIST CENTERED",
  "AUTHENTIC MUAY THAI",
  "ST. AUGUSTINE, FL",
  "DISCIPLINE",
  "THE ART OF EIGHT LIMBS",
  "CLEAN COMMUNITY",
];

// Instagram Reels wall — a curated list of reel permalinks from
// @war.room.performance. Rendered by <Reels /> as native Instagram embeds
// (blockquote + //www.instagram.com/embed.js), so the actual video, caption,
// like/comment counts stay live from Instagram itself. Update this array
// whenever you post a reel you want featured on the site.
export const INSTAGRAM_REELS = [
  "https://www.instagram.com/reel/DcOyIWYR2dG/",
  "https://www.instagram.com/reel/Db3q4uap0uz/",
  "https://www.instagram.com/reel/Db91sY3NyR4/",
  "https://www.instagram.com/reel/Dbaq9gAOF2l/",
  "https://www.instagram.com/reel/DVfBgYsjc0q/",
];
